import React, { Component } from "react";
import "./LoginMessageBox.css";
import warningIcon from "../../images/icon-login-warning.png";
import { isMobile } from "react-device-detect";

export default class LoginMessageBox extends Component {
  constructor(props) {
    super(props);
    this.handleDismiss = this.props.handleDismiss;
  }

  render() {
    const {isVisible,message} = this.props;
    if (!isVisible) return null;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    let messageTitle,
      messageBody,
      cancelButtonText,
      confirmButtonText,
      confirmButtonUrl;

    if (lang === "en") {
      messageTitle = "Notice";
      messageBody =
        "As a 3SUPREME customer, you are invited to visit www.3supreme.vip to enjoy superior experience and exclusive offers.";
      cancelButtonText = "Later";
      confirmButtonText = "Visit Now";
      confirmButtonUrl = "https://www.3supreme.vip/en/index.html";
    } else {
      messageTitle = "登入提示";
      messageBody =
        "閣下之流動電話賬戶已晉升至3SUPREME客戶。為提升客戶體驗，現邀請你到為3SUPREME客戶而設的網頁www.3supreme.vip，盡享貼心服務及專享優惠。";
      cancelButtonText = "再想想 ";
      confirmButtonText = "前往網頁";
      confirmButtonUrl = "https://www.3supreme.vip/index.html";
    }

    return (
      <div>
        <div class="loginMessageOverlay" />
        <div className="loginMessagePopUpContainer">
          <img class="img-warning" src={warningIcon} alt="Warning" />

          <div class="message-title">{messageTitle}</div>
          <p class="message-body" dangerouslySetInnerHTML={{__html:message !== "" ? message : messageBody}}></p>

          <div class="btn-container">
            <button
              class="popup-btn btn-cancel"
              type="button"
              onClick={this.handleDismiss}
            >
              {cancelButtonText}
            </button>
            <a class="popup-btn btn-confirm" href={confirmButtonUrl}>
              {confirmButtonText}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
